export default __webpack_public_path__ + "static/media/ledger-device.a82a27c9.png";